<template>
  <v-app id="app-login">
    <v-layout row wrap style="position: fixed; right: 0; top: 0; z-index: 9999; width: 150px">
      <v-flex xs12 text-xs-right>
        <v-btn color="primary" style="border-radius: 5px" @click="setdemo()">demo</v-btn>
      </v-flex>
    </v-layout>
    <!-- <img src="../assets/beta1.png" style="position: fixed;right: 0;top: 0;z-index:9999;width:150px"> -->
    <v-container fluid fill-height back-ground>
      <v-layout align-center justify-center>
        <v-flex lg4 md6 sm8 xs12>
          <v-card color="rgb(255, 255, 255, 1)" class="radius">
            <v-card-text>
              <v-layout row wrap>
                <v-flex lg12 md8 xs12 text-xs-center>
                  <img src="/static/logo/coconutlogo.png" width="300" height="150" class="hidden-xs-only" />
                  <img src="/static/logo/coconutlogo.png" width="300" height="150" class="hidden-sm-and-up" />
                </v-flex>
                <v-flex lg12 md12 xs12 mt-3 px-3>
                  <v-form v-model="form_valid">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h2>{{ $t("login") }}</h2>
                      </v-flex>
                      <v-flex xs12 mt-3>
                        <v-text-field
                          required
                          type="text"
                          :label="$t('user_name')"
                          append-icon="person"
                          v-on:keyup.enter="userEnter()"
                          v-model="form_model.username"
                          :rules="form_rules.username"
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          id="password-text"
                          required
                          type="password"
                          :label="$t('password')"
                          v-on:keyup.enter="passwordEnter()"
                          append-icon="vpn_key"
                          v-model="form_model.password"
                          :rules="form_rules.password"
                        />
                      </v-flex>
                      <v-flex xs12>
                        <!-- <h3 style="color:red; font-size:0.9em;">{{errMessage}}</h3> -->
                      </v-flex>
                    </v-layout>
                  </v-form>
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-btn color="primary" block style="height: 3em" v-text="$t('sign_in')" @click="onLoginClick()" />
                      </v-flex>
                      <v-flex xs12 text-xs-center style="margin-top: 15px">
                        <router-link to="/register">{{ $t("register") }}</router-link
                        >&nbsp;|&nbsp;
                        <router-link to="/forget/password">{{ $t("forget_password") }}</router-link
                        >&nbsp;|&nbsp;
                        <router-link to="/user-manual">{{ $t("user_manual") }}</router-link>
                      </v-flex>
                      <v-flex xs6 text-xs-left style="margin-top: 25px">
                        <span
                          style="
                            margin-top: -10px;
                            color: #757575;
                            margin-left: -20px;
                          "
                          >Version {{ version }} &nbsp;</span
                        >
                      </v-flex>
                      <v-flex xs6 text-xs-right style="margin-top: 10px">
                        <span style="margin-top: -10px">{{ $t("language") }} &nbsp;</span>
                        <img
                          src="../assets/thailand.png"
                          style="
                            right: 0;
                            top: 0;
                            z-index: 9999;
                            width: 20px;
                            margin-top: 10px;
                          "
                          @click="switchLang('th')"
                        />
                        <img
                          src="../assets/england.png"
                          style="
                            right: 0;
                            top: 0;
                            z-index: 9999;
                            width: 20px;
                            margin-left: 15px;
                            margin-top: 10px;
                          "
                          @click="switchLang('en')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :right="'right'" :color="snack_model.type">
          {{ snack_model.msg }}
          <v-btn dark flat icon @click="snack_model.status = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-snackbar>
      </v-layout>
    </v-container>
    <div class="text-xs-center">
      <v-dialog v-model="dialog" width="500" transition="dialog-bottom-transition" :overlay="false" persistent>
        <v-card>
          <v-toolbar dark color="primary">
            <v-tooltip bottom>
              <v-btn slot="activator" icon dark @click="dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
              <span>{{ $t("close") }}</span>
            </v-tooltip>
            <v-toolbar-title>{{ $t("select_shop") }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-0">
            <v-flex md12 sm12 xs12 v-for="(item, index) in shopList" :key="index" @click="onListClick(item)">
              <v-card class="coco-box-shadow coco-list-hover">
                <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                  <v-flex xs12 pa-2>
                    <span>{{ item.company.name }}</span>
                  </v-flex>
                  <v-flex xs12 class="coco-list-divider">
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-card-text>
          <v-card-actions class="mt-4">
            <v-btn block color="cyan" dark @click="goto('shop/create')">{{ $t("create_shop") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-layout row justify-center>
      <v-dialog v-model="dialoglogin" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{ $t("message.loginfail") }}</v-card-title>
          <v-card-text test-xs-center>{{ $t("message.loginfailDetail") }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click="dialoglogin = false">ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-app>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import $ from "jquery";
import UserService from "@/services/UserService";
import SettingService from "@/services/SettingService";
export default {
  data: () => ({
    currentLang: {},
    languages: [],
    dialog: false,
    dialoglogin: false,
    form_valid: false,
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    form_model: {
      username: "",
      password: "",
    },
    form_rules: {
      username: [(v) => !!v || "do not empty."],
      password: [(v) => !!v || "do not empty."],
    },
    errMessage: "",
    loading: false,
  }),
  computed: {
    ...mapState("auth", ["loginSuccess", "loginErrorMsg", "shopList"]),
    ...mapState("permissionmenu", ["permission_List"]),
    ...mapState("app", ["version"]),
  },
  methods: {
    ...mapActions("auth", ["login"]),
    ...mapActions("permissionmenu", ["getPermission"]),
    ...mapMutations("permissionmenu", ["getAllPermission"]),
    goto(path) {
      this.$router.push("/" + path);
    },
    userEnter() {
      $("#password-text").focus();
    },
    passwordEnter() {
      this.onLoginClick();
    },
    initLang() {
      for (let langKey in this.$i18n.messages) {
        this.languages[this.languages.length] = {
          code: langKey,
          title: this.$i18n.messages[langKey].lang,
        };
      }

      if (localStorage.getItem("lang")) {
        this.$i18n.locale = localStorage.getItem("lang");
      }
      this.currentLang = this.$i18n.locale;
      console.log(this.currentLang);
    },
    switchLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      this.currentLang = this.$i18n.locale;
      console.log(lang);
    },
    onListClick(data) {
      localStorage._company_guid = data.company.company_guid;
      localStorage._company_name = data.company.name;
      if (data.company.is_timeattendance == null) {
        localStorage._is_timeattendance = "0";
      } else {
        localStorage._is_timeattendance = data.company.is_timeattendance;
      }

      localStorage.lang = this.currentLang;
      console.log(data);

      if (data.is_admin == 1) {
        localStorage._is_admin = true; //admin
      } else {
        localStorage._is_admin = false; //Employee
      }
      localStorage._usercode = data.user.usercode;
      localStorage._email = data.user.email;
      localStorage._verify = data.user.verify;

      UserService.getVerifyDB({ company_guid: localStorage._company_guid })
        .then((res) => {
          this.getCompanyAddress();
        })
        .catch((err) => {
          this.getCompanyAddress();
        });
    },
    onchecknewshop(is_newshop) {
      if (localStorage._is_admin.toString() == "false") {
        this._getEmpByuserCode();
      } else {
        if (is_newshop == "0") {
          this.$router.push("/wizardsetting");
        } else {
          this.$router.push("/");
        }
      }
    },
    getCompanyAddress() {
      SettingService.getCompanyAddress()
        .then((res) => {
          console.log("getCompanyAddress", res.data.content);
          if (res.data.content.length > 0) {
            this.onchecknewshop("1");
          } else {
            this.onchecknewshop("0");
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        });
    },
    async _getEmpByuserCode() {
      await UserService.getEmpByuserCode(this.form_model.username)
        .then(async (res) => {
          if (res && res.data.code != undefined && res.data.is_active.toString() == "true") {
            console.log("if");
            localStorage._empcode = res.data.code;
            await this._getPermissionByuserCode();
            this.$router.push("/emp");
          } else {
            console.log("else");
            localStorage._is_admin = undefined;
            localStorage._empcode = "";
            this.$router.push("/login");
            this.dialoglogin = true;
          }
        })
        .catch((err) => {
          console.log("catch");
          localStorage._empcode = "";
        });
    },
    async _getPermissionByuserCode() {
      await this.getPermission({ code: localStorage._empcode });
      //console.log("ssss",this.permission_List);
    },
    async onLoginClick() {
      localStorage.removeItem("_token");
      this.loading = true;
      await this.login({
        username: this.form_model.username,
        password: this.form_model.password,
      });
      console.log("login", this.form_model.username, this.form_model.password);
      if (this.loginSuccess) {
        if (this.shopList.length > 1) {
          this.dialog = true;
          this.loading = false;
        } else {
          // if (this.shopList.length > 0) {
          //   this.onListClick(this.shopList[0]);
          // } else {
          this.dialog = true;
          this.loading = false;
          // }
        }
      } else {
        // this.errMessage ="ไม่สามารถ เข้าสู่ระบบได้ email หรือ password ไม่ถูกต้อง";
        this.snack_model.status = true;
        this.snack_model.msg = "ไม่สามารถ เข้าสู่ระบบได้ email หรือ password ไม่ถูกต้อง";
        this.snack_model.type = "error";
        this.loading = false;
      }
    },
    setdemo() {
      this.form_model.username = "demomode";
      this.form_model.password = "1234";
      this.onLoginClick();
    },
  },
  created() {
    this.initLang();
    if (localStorage._token != undefined && localStorage._token != "") {
      this.goto("");
    }
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");
h2,
span {
  font-family: "Prompt", sans-serif;
}
.back-ground {
  background: linear-gradient(to bottom right, #3399ff, #00cc66) !important ;
  background-size: cover;
}
.radius {
  border-radius: 15px;
}
.v-card__text {
  padding: 16px !important;
}
</style>
